<template>
  <div class="search-item-category">
    <a :href="link" class="search-item-category__link">
      <span class="search-item-category__icon">
        <svg
          width="14" height="14"
          viewBox="0 0 14 14" fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd" clip-rule="evenodd"
            d="M0.25 0.781518C0.25 0.489131 0.487026 0.252106 0.779412 0.252106H5.72059C6.01297 0.252106 6.25 0.489131 6.25 0.781518V5.72269C6.25 6.01508 6.01297 6.25211 5.72059 6.25211H0.779412C0.487026 6.25211 0.25 6.01508 0.25 5.72269V0.781518ZM1.30882 1.31093V5.19328H5.19118V1.31093H1.30882Z" fill="#333332"
          />
          <path
            fill-rule="evenodd" clip-rule="evenodd"
            d="M7.75 0.781518C7.75 0.489131 7.98703 0.252106 8.27941 0.252106H13.2206C13.513 0.252106 13.75 0.489131 13.75 0.781518V5.72269C13.75 6.01508 13.513 6.25211 13.2206 6.25211H8.27941C7.98703 6.25211 7.75 6.01508 7.75 5.72269V0.781518ZM8.80882 1.31093V5.19328H12.6912V1.31093H8.80882Z" fill="#333332"
          />
          <path
            fill-rule="evenodd" clip-rule="evenodd"
            d="M7.75 8.27731C7.75 7.98492 7.98703 7.74789 8.27941 7.74789H13.2206C13.513 7.74789 13.75 7.98492 13.75 8.27731V13.2185C13.75 13.5109 13.513 13.7479 13.2206 13.7479H8.27941C7.98703 13.7479 7.75 13.5109 7.75 13.2185V8.27731ZM8.80882 8.80672V12.6891H12.6912V8.80672H8.80882Z" fill="#333332"
          />
          <path
            fill-rule="evenodd" clip-rule="evenodd"
            d="M0.25 8.27731C0.25 7.98492 0.487026 7.74789 0.779412 7.74789H5.72059C6.01297 7.74789 6.25 7.98492 6.25 8.27731V13.2185C6.25 13.5109 6.01297 13.7479 5.72059 13.7479H0.779412C0.487026 13.7479 0.25 13.5109 0.25 13.2185V8.27731ZM1.30882 8.80672V12.6891H5.19118V8.80672H1.30882Z" fill="#333332"
          />
        </svg>
      </span>
      <p class="search-item-category__name">{{ name }}</p>
    </a>
  </div>
</template>

<script>
export default {
  name: 'search-item-category',

  props: {
    name: {
      type: String,
      default: '',
    },

    link: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.search-item-category {
  padding: 8px 0;

  &__link {
    display: flex;
    align-items: center;

    &:hover,
    &:active,
    &:focus-visible {
      & .search-item-category__name {
        color: #E30613;
      }
    }
  }

  &__icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    opacity: .3;
  }

  &__name {
    overflow: hidden;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #333332;
    white-space: nowrap;
    text-overflow: ellipsis;

    @media (max-width: 950px) {
      inline-size: calc(100% - 40px);
    }
  }
}
</style>
